export default [
  {
    path: '/banner',
    name: 'banner',
    component: () => import('@/views/menu/banner/banner.vue'),
    meta: {
      pageTitle: 'مدیریت بنرها',
      action: 'show',
      resource: 'BannerManager',
    },
  },
  {
    path: '/banner/details',
    name: 'addbanner',
    component: () => import('@/views/menu/banner/bannerdetails.vue'),
    meta: {
      pageTitle: 'ایجاد بنر',
      action: 'show',
      resource: 'BannerManager',
    },
  },
  {
    path: '/banner/details/:id',
    name: 'updatebanner',
    component: () => import('@/views/menu/banner/bannerdetails.vue'),
    meta: {
      pageTitle: 'ویرایش بنر',
      action: 'show',
      resource: 'BannerManager',
    },
  },
  {
    path: '/bannerposition',
    name: 'bannerposition',
    component: () => import('@/views/menu/banner/bannerposition.vue'),
    meta: {
      pageTitle: 'مدیریت جایگاه بنر',
      action: 'show',
      resource: 'BannerManager',
    },
  },
]
